import { useEffect } from "react";
import { useTouchscreenContext } from "@touchscreen/hooks";
import { writeLastVenueRef } from "./lib/lastVenue.js";

/** Persists the resolved venue ref once the session is up, enabling the Resume entry path. */
export function VenuePersister(props: { venueRef: string }): null {
  const { boot } = useTouchscreenContext();

  useEffect(() => {
    if (boot.status === "ready") {
      writeLastVenueRef(props.venueRef);
    }
  }, [boot.status, props.venueRef]);

  return null;
}
